module.exports = __webpack_public_path__ + "img/icon_iphone.b663b228.png";